export var FetchResult = Promise; // TS -> async ES5 compatibility
